export function getLicenseFromUrl() {
  const url = new URL(window.location.href)
  const pathSegments = url.pathname.split('/').filter(Boolean)

  if (pathSegments[0] === 'settings') {
    return ''
  }

  const license = pathSegments[2]
  return license
}
